module.exports = __webpack_public_path__ + "static/media/soft-hard-sign.403b3c6c.png";